import { render, staticRenderFns } from "./AdCluster.vue?vue&type=template&id=588bde6e&scoped=true&"
import script from "./AdCluster.vue?vue&type=script&lang=js&"
export * from "./AdCluster.vue?vue&type=script&lang=js&"
import style0 from "./AdCluster.vue?vue&type=style&index=0&id=588bde6e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bde6e",
  null
  
)

export default component.exports